import { DurationLabels, formatMinutesDuration } from './duration'

export const formatBillingDecimal = (value: string, language: string): string =>
  new Intl.NumberFormat(language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value))

export const formatBillingAmount = (amount: number, language: string): string =>
  new Intl.NumberFormat(language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount / 100)

const decimalHoursToMinutes = (
  value: string,
  roundUpToHour = false
): number => {
  const hours = Number(value)

  return roundUpToHour ? Math.ceil(hours) * 60 : Math.round(hours * 60)
}

export const formatExitGracePeriod = (
  totalMinutes: number,
  language: string,
  hourLabel: string,
  minuteLabel: string
): string => {
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  const formatter = new Intl.NumberFormat(language)

  return [
    hours > 0 ? `${formatter.format(hours)} ${hourLabel}` : '',
    minutes > 0 || hours === 0
      ? `${formatter.format(minutes)} ${minuteLabel}`
      : '',
  ]
    .filter(Boolean)
    .join(' ')
}

export const formatBillingDuration = (
  value: string,
  language: string,
  labels: DurationLabels,
  roundUpToHour = false
): string =>
  formatMinutesDuration(
    decimalHoursToMinutes(value, roundUpToHour),
    language,
    labels
  )
